import React from 'react';
import Navbar from '../components/Navbar';
import BackgroundVideo from '../components/BackgroundVideo';
import HeroSection from '../components/HeroVideo';
import Pricing from '../components/Pricing';
import Services from '../components/Services';
import Process from '../components/Process';
import AssetClasses from '../components/AssetClasses';
import Referrals from '../components/Referrals';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="relative text-[#ECE9DF]">
      <BackgroundVideo />
      <div className="relative z-10">
        <Navbar />
        <HeroSection />
        <Pricing />
        <Services />
        <Process />
        <AssetClasses />
        <Referrals />
        <CTA />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
